import { useId } from 'react';
import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import styles from './styles.module.css';

type Props = {
  className?: string;
  labelClassName?: string;
  label: string;
  readOnly?: boolean;
  value: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Checkbox = (props: Props) => {
  const id = useId();

  return (
    <div className={props.className}>
      <input
        id={id}
        className={clsx('hidden', styles.checkbox)}
        type='checkbox'
        readOnly={props.readOnly}
        checked={props.value}
        onChange={props.onChange}
      />
      <label
        htmlFor={id}
        className={clsx(
          'flex items-center gap-2 font-normal text-sm text-slate dark:!text-white select-none cursor-pointer',
          styles.label,
          PaletteUtils.isVcfcPalette && styles.vcfc,
          props.readOnly && styles.readonly,
          props.labelClassName,
        )}
      >
        {props.label}
      </label>
    </div>
  );
};
